export enum ButtonTypeEnum {
  DEFAULT = "mp-btn",
  ICON = "mp-btn-icone",
  SQUARE = "mp-btn-toggle",
  OUTLINE= "mp-btn-outline",

}
